var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import DateService from "./Shared/Date.service";
const BASE_URL = "/aviso/stats";
export default class StatsService {
    // prettier-ignore
    static getAttendedAndMissedByTerm(transcriptId, period, rangeFrom, rangeTo) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield FetchService.getSingleResponse(BASE_URL + "/getAttendedAndMissedByTerm", {
                transcriptId,
                period,
                rangeFrom,
                rangeTo,
            });
            // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'datum' implicitly has an 'any' type.
            return data.map((datum) => ({
                numAttended: datum.numAttended,
                numMissed: datum.numMissed,
                date: DateService.getStartOfDay(DateService.parseDateWithSameTimeInLocalTimezone(datum.date)),
            }));
        });
    }
    // prettier-ignore
    static getTranscriptGpaHistoryData(transcriptId, period, aggregation, property, fromDate, toDate) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield FetchService.getSingleResponse(BASE_URL + "/getTranscriptGpaHistoryData", {
                transcriptId,
                period,
                aggregation,
                property,
                fromDate,
                toDate,
            });
            // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'datum' implicitly has an 'any' type.
            return data.map((datum) => ({
                data: datum.data,
                date: DateService.getStartOfDay(DateService.parseDateWithSameTimeInLocalTimezone(datum.date)),
            }));
        });
    }
    // prettier-ignore
    static getMinCourseRiskHistoryForTranscriptAndTerm(transcriptId, academicCalendarId, period, rangeFrom, rangeTo) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield FetchService.getSingleResponse(BASE_URL + "/getMinCourseRiskHistoryForTranscriptAndTerm", {
                transcriptId,
                academicCalendarId,
                period,
                rangeFrom,
                rangeTo,
            });
            console.log(data);
            // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'datum' implicitly has an 'any' type.
            return data.map((datum) => (Object.assign(Object.assign({}, datum), { date: DateService.getStartOfDay(DateService.parseDateWithSameTimeInLocalTimezone(datum.date)) })));
        });
    }
    // prettier-ignore
    static getAvgPersistenceRiskHistoryForPersonAndTerm(personId, rangeFrom, rangeTo) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield FetchService.getSingleResponse(BASE_URL + "/getAvgPersistenceRiskHistoryForPersonAndTerm", {
                personId,
                rangeFrom,
                rangeTo,
            });
            // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'datum' implicitly has an 'any' type.
            return data.map((datum) => (Object.assign(Object.assign({}, datum), { academicCalendarStartDate: new Date(datum.academicCalendarStartDate) })));
        });
    }
}
